import React, { useEffect, useState } from 'react';
import { Image } from '@lt/components';
import { Close } from '@lt/components/icons-react';
import classnames from 'classnames';
import Cookies from 'js-cookie';
import { KEY_PROMO_COOKIE } from './constants';
import styles from './PromoBanner.module.css';
import bannerDesktopSmall from '../../../images/promo_banner/banner_checkout_desktop_small.webp';
import bannerDesktopFullscreen from '../../../images/promo_banner/banner_checkout_desktop_fullscreen.webp';
import bannerMobileSmall from '../../../images/promo_banner/banner_checkout_mobile_small.webp';
import bannerMobileFullscreen from '../../../images/promo_banner/banner_checkout_mobile_fullscreen.webp';

interface PromoBannerProps {
  isMobile: boolean;
  showTourGuide?: boolean;
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
  isMobile,
  showTourGuide,
}) => {
  const [isActive, setIsActive] = useState(() => {
    const cookieValue = Cookies.get(KEY_PROMO_COOKIE);
    return cookieValue ? Boolean(JSON.parse(cookieValue)) : true;
  });

  useEffect(() => {
    const cookieValue = Cookies.get(KEY_PROMO_COOKIE);
    const value = cookieValue ? Boolean(JSON.parse(cookieValue)) : true;
    setIsActive(value);
  }, []);

  const handleCloseBanner = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsActive(false);
    Cookies.set(KEY_PROMO_COOKIE, JSON.stringify(false));
    window.dispatchEvent(
      new CustomEvent('promoBannerCookieChange', {
        detail: { value: false },
      }),
    );
  };

  if (!isActive) {
    return null;
  }

  let bannerSrc;
  if (isMobile) {
    bannerSrc = showTourGuide ? bannerMobileSmall : bannerMobileFullscreen;
  } else {
    bannerSrc = showTourGuide ? bannerDesktopSmall : bannerDesktopFullscreen;
  }

  const isMobileFullscreen = isMobile && !showTourGuide;

  return (
    <>
      <div
        className={classnames(styles.container, {
          [styles.containerMobileSwiper]: isMobile && showTourGuide,
          [styles.containerMobileFullscreen]: isMobileFullscreen,
        })}
      >
        {isMobileFullscreen ? (
          <div className={styles.bannerWrapperMobileFullscreen}>
            <Image
              src={bannerSrc}
              alt="Промо-баннер"
              className={classnames(styles.banner)}
              fallback=""
            />
            <Close className={styles.closeIcon} onClick={handleCloseBanner} />
          </div>
        ) : (
          <>
            <Image
              src={bannerSrc}
              alt="Промо-баннер"
              className={styles.banner}
              fallback=""
            />
            <Close className={styles.closeIcon} onClick={handleCloseBanner} />
          </>
        )}
      </div>
    </>
  );
};
